module.exports = __webpack_public_path__ + "static/media/linkedin.034455cd.svg";